import React from 'react';

import { createStyles, withStyles, WithStyles } from '@material-ui/core';

import IconDotsTyping from '../WIP/ui-core/IconDotsTyping';

const styles = () =>
  createStyles({
    wrapperLoading: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  });

interface ContentLoaderProps extends WithStyles<typeof styles> {}

const ContentLoader: React.FC<ContentLoaderProps> = ({ classes }) => (
  <div className={classes.wrapperLoading}>
    <IconDotsTyping />
  </div>
);

export default withStyles(styles, { name: 'ContentLoader' })(ContentLoader);
